export default __webpack_public_path__ + "static/media/web_screen_engage_de.649e0551.png";